import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { Brand } from '@fametrue/shared';
import { FamecertBadge } from './FamecertBadge';
import { brandDotClass } from './palette';

/**
 * Testata del brand, comune alle tre viste.
 *
 * Era lo stesso markup ripetuto in quattro punti — Insight, Decision e due
 * volte Intelligence — e la prova che fosse di troppo è che bastava cambiare
 * una parola ("Agg." in "Aggiornato al", 16/10 punto 8) per doverlo toccare in
 * quattro file.
 *
 * Il verdetto `matrixLabel` non è reso: dal v40 resta solo il colore del
 * pallino. Il badge Famecert manca nel solo ramo dell'Intelligence senza
 * benchmark, che è una schermata di avviso e non una vista.
 */
export function BrandHeader({ brand, badge = true }: { brand: Brand; badge?: boolean }): ReactNode {
  const { t } = useTranslation();

  return (
    <div className="brand-header">
      <div className={`brand-dot ${brandDotClass(brand.classification.matrixColor)}`} />
      <span className="brand-name">{brand.name}</span>
      {badge ? <FamecertBadge status={brand.famecertStatus} /> : null}
      <span className="brand-date">
        {t('insight.updated')} {brand.lastUpdated}
      </span>
    </div>
  );
}
